// src/pages/Budget_entering/mockData.js
// Справочники АРМ «Доходы и расходы», используемые api.js.
//
// SECTIONS — резервная копия на случай, если GET /api/arm/budget/sections
// не отдаст пригодный ответ (контракт этого эндпоинта Swagger не типизирует).
// BUDGETS — виды бюджета: под них в контроллере нет эндпоинта, список фиксирован.
// REF_SECTIONS/NO_EXEC_SECT/RES_SECTIONS/USE_SECTIONS/TOLERANCE — бизнес-правила
// (какие разделы справочные, из чего складывается баланс, допуск тождеств) —
// это не данные с сервера, а классификация, зашитая в форму и расчёт баланса.

/* Разделы отчёта (19 значений). part — часть баланса для цветного чипа:
   inc — доходы (синий), exp — расходы (янтарный), fin — финансирование (серый),
   ref — справочно (сиреневый). Названия из справочника не переводятся ключами
   словаря — берутся по языку из ru/kk. */
export const SECTIONS = [
  { k: 'INC', part: 'inc', ru: 'I. ДОХОДЫ', kk: 'I. КІРІСТЕР' },
  { k: 'EXP', part: 'exp', ru: 'II. ЗАТРАТЫ', kk: 'II. ШЫҒЫНДАР' },
  {
    k: 'NBL',
    part: 'fin',
    ru: 'III. Чистое бюджетное кредитование',
    kk: 'III. Таза бюджеттік кредиттеу',
  },
  { k: 'BC', part: 'fin', ru: '· Бюджетные кредиты', kk: '· Бюджеттік кредиттер' },
  {
    k: 'BCR',
    part: 'fin',
    ru: '· Погашение бюджетных кредитов',
    kk: '· Бюджеттік кредиттерді өтеу',
  },
  {
    k: 'FAS',
    part: 'fin',
    ru: 'IV. Сальдо по операциям с фин. активами',
    kk: 'IV. Қаржы активтерімен операциялар сальдосы',
  },
  {
    k: 'FAP',
    part: 'fin',
    ru: '· Приобретение финансовых активов',
    kk: '· Қаржы активтерін сатып алу',
  },
  {
    k: 'FAI',
    part: 'fin',
    ru: '· Поступления от продажи фин. активов',
    kk: '· Қаржы активтерін сатудан түсімдер',
  },
  {
    k: 'DEF',
    part: 'fin',
    ru: 'V. Дефицит (профицит) бюджета',
    kk: 'V. Бюджет тапшылығы (профициті)',
  },
  {
    k: 'NOD',
    part: 'fin',
    ru: 'VI. Ненефтяной дефицит (профицит)',
    kk: 'VI. Мұнайлық емес тапшылық (профицит)',
  },
  { k: 'FND', part: 'fin', ru: 'VII. Финансирование дефицита', kk: 'VII. Тапшылықты қаржыландыру' },
  { k: 'LNI', part: 'fin', ru: '· Поступление займов', kk: '· Қарыздар түсімі' },
  { k: 'LNR', part: 'fin', ru: '· Погашение займов', kk: '· Қарыздарды өтеу' },
  {
    k: 'USB',
    part: 'fin',
    ru: '· Используемые остатки бюджетных средств',
    kk: '· Пайдаланылатын бюджет қалдықтары',
  },
  {
    k: 'REF',
    part: 'ref',
    ru: 'Справочно: остатки бюджетных средств',
    kk: 'Анықтама: бюджет қаражатының қалдықтары',
  },
  {
    k: 'BAL_B',
    part: 'ref',
    ru: '· Остатки на начало финансового года',
    kk: '· Қаржы жылының басындағы қалдықтар',
  },
  {
    k: 'BAL_T',
    part: 'ref',
    ru: '· Временно привлечённые / отвлечённые остатки',
    kk: '· Уақытша тартылған / бұрылған қалдықтар',
  },
  {
    k: 'BAL_E',
    part: 'ref',
    ru: '· Остатки на конец отчётного периода',
    kk: '· Есепті кезең соңындағы қалдықтар',
  },
  {
    k: 'BAL_X',
    part: 'ref',
    ru: '· в том числе за счёт внешних займов',
    kk: '· соның ішінде сыртқы қарыздар есебінен',
  },
];

/* Виды бюджета (3 значения). region — для сверки при загрузке файла. */
export const BUDGETS = [
  {
    k: '8',
    ru: '8 — Бюджет района (район и его МСУ)',
    kk: '8 — Аудан бюджеті (аудан және ЖӨБ)',
    region: '150900-Жылыойский район (район и его МСУ)',
  },
  {
    k: '3',
    ru: '3 — Районный бюджет',
    kk: '3 — Аудандық бюджет',
    region: '150901-Жылыойский район',
  },
  {
    k: '7',
    ru: '7 — Бюджет МСУ',
    kk: '7 — ЖӨБ бюджеті',
    region: '150900-Жылыойский район (район и его МСУ)',
  },
];

/* Числовые поля строки (колонки 3–10 отчёта). */
export const NUMF = ['ab', 'ub', 'adj', 'pp', 'cp', 'ca', 'ua', 'ex'];

/* Справочные разделы: годовой бюджет и план платежей в отчёте не заполняются
   (блоки 2 и 3 формы скрыты), пустые ячейки пишутся как NULL, не как 0. */
export const REF_SECTIONS = ['REF', 'BAL_B', 'BAL_T', 'BAL_E', 'BAL_X'];
/* Разделы, для которых пустое исполнение допустимо. */
export const NO_EXEC_SECT = ['REF', 'BAL_T', 'BAL_X'];

/* Слагаемые балансовых тождеств (по строкам-итогам разделов). */
export const RES_SECTIONS = ['INC', 'BCR', 'FAI', 'LNI', 'BAL_B', 'BAL_T'];
export const USE_SECTIONS = ['EXP', 'BC', 'FAP', 'LNR', 'BAL_E'];

/* Единый допуск балансовых тождеств — тот же, что в дашборде: 0,001 тыс. ₸.
   Отдельного meta-эндпоинта под него в API нет (есть только внутри ответа
   periods/{id}/integrity) — используется как константа. */
export const TOLERANCE = 0.001;

